<template>
	<v-layout justify-center class="create">
		<v-flex xs12>
			<v-container>
				<MultiImageBox :remove="remove" :is-overview="isOverview" :add="false" />
			</v-container>
		</v-flex>
	</v-layout>
</template>

<script>
import MultiImageBox from '@/components/MultiImageBox.vue'

export default {
	name: 'Edit',
	components: {
		MultiImageBox
	},
	props: {
		resetEdit: {
			type: Function,
			required: true
		},
		isOverview: {
			type: Boolean,
			required: true
		}
	},
	computed: {
		cards() {
			return this.$store.state.cards
		},
		images() {
			return this.$store.state.images
		}
	},
	methods: {
		remove(id) {
			var item = {
				table: this.isOverview ? 'vacation' : 'images',
				id: id
			}
			this.$store.dispatch('delete', item)
			if (this.isOverview) {
				this.$store.commit(
					'setCards',
					this.cards.filter(source => {
						return source.id !== id
					})
				)
			} else {
				this.$store.commit(
					'setImages',
					this.images.filter(source => {
						return source.id !== id
					})
				)
			}
		}
	}
}
</script>
